import Compress from '@mui/icons-material/Compress';
import Expand from '@mui/icons-material/Expand';
import Settings from '@mui/icons-material/Settings';
import { Box, Button, IconButton, ListItemIcon, ListItemText, MenuItem, Popover, Tooltip } from '@mui/material';
import React, { MouseEvent, useCallback, useState } from 'react';
import ParametroStore from '../store/ParametroStore';
import { IconeNovo } from './IconeNovo';

const SettingsPopover: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handlePopoverOpen = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handlePopoverClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);

  const handleToggleModoCompacto = () => {
    ParametroStore.toggleVisualizacaoCompacta();
    handlePopoverClose();
  };

  return (
    <div>
        <Tooltip title="Configurações">
          <IconButton color="inherit" onClick={handlePopoverOpen}>
            <Settings/>
          </IconButton>
        </Tooltip>
        <Popover
          open={open}
          onClose={handlePopoverClose}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          PaperProps={{
            sx: {
              boxShadow: 3,
              borderRadius: 1,
              minWidth: 200,
              py: 1
            }
          }}
          sx={{ mt: '15px' }}>
          <MenuItem
            onClick={handleToggleModoCompacto}
            sx={{
              borderLeft: '4px solid #005aa5',
              pl: 1.5,
            }}
          >
            <ListItemIcon>
              {ParametroStore.visualizacaoCompacta ? <Expand /> : <Compress />}
            </ListItemIcon>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ListItemText
                primary={
                  ParametroStore.visualizacaoCompacta
                    ? 'Desativar Modo Compacto'
                    : 'Ativar Modo Compacto'
                }
              />
              <IconeNovo label="NOVO" />
            </Box>
          </MenuItem>
        </Popover>
    </div>
  );
};

export default SettingsPopover;
